import { useState } from 'react'
import DepositForm from './DepositForm'
import { useUserContext } from '../../hooks/auth/UserProvider';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function Deposit() {
  const [statusResponse, setStatusResponse] = useState<boolean>(false);
  const {isForbidden} = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    if(isForbidden){
      navigate('/');
    }
  }, [isForbidden]);

  return (
    !isForbidden ? <>
      <DepositForm status={statusResponse} setStatus={setStatusResponse} />
      {/* <LastDepositTransactionsTable status={statusResponse} /> */}
    </> : <></>
  )
}